// Header Mobile Menu Start

var menu_target = document.querySelectorAll('.menu_toggle');
if(menu_target.length > 0){
  menu_target.forEach(function(menu){
    menu.addEventListener('click',function(e){
      e.preventDefault();
      this.parentNode.classList.toggle('menu_open');
      if(this.classList.contains('menu-open-icon')){
        this.closest('.header-mobile-drawer').querySelector('.header-main__nav.mobile__drawer').classList.add('active');
      }else if(this.classList.contains('menu-close-icon')){
        this.closest('.header-mobile-drawer').querySelector('.header-main__nav.mobile__drawer').classList.remove('active');
      }
    })
  })
}

// Header Mobile Menu End


// Initialize Wow
new WOW().init();

$(".benefits_slider").slick({
  autoplay: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.2,
        centerMode: true,
      }
    }
  ]
});
$(".banner-textSlider").slick({
  autoplay: true,
  autoplaySpeed:3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade:true,
  dots: false
});

$(".benefits_top_slider").slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 5000,
  // speed: 8000,
  slidesToShow: 10,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  dots: false,
  cssEase: 'linear',
});

$(".benefits_top_slider").on("afterChange", function(event, slick, currentSlide){
  if (currentSlide >= slick.slideCount / 2) {
    slick.slickGoTo(0, true); // jump back instantly, no gap
  }
});



$('.essential_slider').slick({
  autoplay: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  variableWidth: true,
  dots: false,
});
 

$("[JSTestimonialSlider]").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  prevArrow:'<button type="button" class="slick-prev"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4658 5.61004C15.6734 5.60619 15.8771 5.66696 16.0487 5.78395C16.2202 5.90095 16.3512 6.06837 16.4234 6.26306C16.4957 6.45774 16.5056 6.67006 16.4519 6.87064C16.3981 7.07122 16.2834 7.25014 16.1235 7.38263L10.0044 12.6211L16.1272 17.8595C16.2391 17.941 16.3328 18.0449 16.4026 18.1645C16.4723 18.2841 16.5164 18.4168 16.5322 18.5543C16.5481 18.6918 16.5352 18.8311 16.4945 18.9634C16.4538 19.0957 16.3861 19.2182 16.2957 19.323C16.2053 19.4278 16.0941 19.5128 15.9692 19.5725C15.8443 19.6322 15.7084 19.6653 15.5701 19.6699C15.4317 19.6744 15.2939 19.6502 15.1654 19.5988C15.0369 19.5474 14.9204 19.47 14.8233 19.3713L7.82362 13.3883C7.71354 13.2943 7.62515 13.1775 7.56455 13.046C7.50394 12.9146 7.47255 12.7715 7.47255 12.6267C7.47255 12.482 7.50394 12.3389 7.56455 12.2074C7.62515 12.076 7.71354 11.9592 7.82362 11.8652L14.8233 5.86326C15.0007 5.70535 15.2284 5.6156 15.4658 5.61004Z" fill="#276371"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.53393 5.6115C8.32631 5.60765 8.12263 5.66843 7.95107 5.78542C7.77951 5.90241 7.64855 6.06983 7.57633 6.26452C7.5041 6.45921 7.49416 6.67153 7.5479 6.87211C7.60164 7.07269 7.7164 7.2516 7.87629 7.3841L13.9953 12.6225L7.87251 17.861C7.76065 17.9425 7.66691 18.0463 7.5972 18.1659C7.52749 18.2855 7.48333 18.4183 7.46751 18.5558C7.45168 18.6933 7.46453 18.8326 7.50525 18.9649C7.54596 19.0972 7.61366 19.2196 7.70407 19.3245C7.79448 19.4293 7.90564 19.5142 8.03052 19.5739C8.15541 19.6336 8.29132 19.6668 8.42967 19.6713C8.56802 19.6759 8.70581 19.6517 8.83434 19.6003C8.96288 19.5489 9.07936 19.4714 9.17645 19.3728L16.1761 13.3898C16.2862 13.2957 16.3746 13.179 16.4352 13.0475C16.4958 12.916 16.5272 12.773 16.5272 12.6282C16.5272 12.4834 16.4958 12.3404 16.4352 12.2089C16.3746 12.0774 16.2862 11.9606 16.1761 11.8666L9.17645 5.86473C8.99907 5.70681 8.77135 5.61707 8.53393 5.6115Z" fill="#276371"/></svg></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$(document).ready(function () {
  $(".themebtn").click(function (e) {
    e.stopPropagation(); // Prevent event bubbling

    let parentItem = $(this).closest(".benefites_item");

    // Remove class from all other items first
    $(".benefites_item").removeClass("benefite_details").each(function () {
      this.style.setProperty("--bg-img", this.dataset.bgImage); // Restore bg image
    });

    // Add class to the clicked item
    parentItem.addClass("benefite_details");

    // Remove --bg-img
    parentItem[0].style.removeProperty("--bg-img");
  });

  // Click anywhere else to remove the class and restore background
  $('.cncl_btn').click(function () {
    $(".benefites_item").removeClass("benefite_details").each(function () {
      this.style.setProperty("--bg-img", this.dataset.bgImage); // Restore bg image
    });
  });

  // Prevent removal when clicking inside `.benefites_item`
  $(".benefites_item").click(function (e) {
    e.stopPropagation();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".benefites_item");

  items.forEach(item => {
    const bgImage = item.style.backgroundImage;
    item.dataset.bgImage = bgImage; // Store original background image
    item.style.setProperty("--bg-img", bgImage); 

    item.addEventListener("mouseenter", function () {
      this.classList.add("active");
    });

    item.addEventListener("mouseleave", function () {
      this.classList.remove("active");
    });
  });
});


function selectBox(clickedBox) {
  if (clickedBox.classList.contains('selected')) {
    clickedBox.classList.remove('selected');
  } else {
    document.querySelectorAll('.box').forEach(box => box.classList.remove('selected'));
    clickedBox.classList.add('selected');
  }
}
 
$(document).ready(function () {
  $(".essential_toggle_detail").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    let parentItem = $(this).closest(".essential_item");

    // Pehle sab cards se class remove kar dein
    $(".essential_item").removeClass("essential_details");

    // Sirf jis card per click ho us par class add karein
    parentItem.addClass("essential_details");
  });

  $(".essential_toggle_less").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    let parentItem = $(this).closest(".essential_item");

    // Sirf isi card se class remove karein
    parentItem.removeClass("essential_details");
  });

  // Jab document (kahin bhi) click ho to sab cards reset ho jayein
  $(document).click(function () {
    $(".essential_item").removeClass("essential_details");
  });

  // `.essential_item` par click hone se event propagate na ho
  $(".essential_item").click(function (e) {
    e.stopPropagation();
  });
});

function showTab(index) {
  let tabs = document.querySelectorAll(".tab");
  let contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => tab.classList.remove("active"));
  contents.forEach(content => content.classList.remove("active"));

  tabs[index].classList.add("active");
  contents[index].classList.add("active");
}
// const texts = ["STRESS", "CORTISOL", "MOOD", "CLARITY AND FOCUS"];
// // const imageUrl = "https://cdn.shopify.com/s/files/1/0663/7902/2383/files/logo_white.png?v=1743533571";
// let index = 0;
// const textContainer = document.getElementById("text_animating");

// function displayContent() {
//     textContainer.innerHTML = "";

//     // if (index < texts.length) {
//         // Display text letter by letter, including spaces
//         const currentText = texts[index];
//   console.log(currentText)
//         currentText.split("").forEach((char, i) => {
//             let span = document.createElement("span");
//             span.classList.add("letter");
//             span.style.animationDelay = `${i * 0.1}s`;
//             span.innerHTML = char === " " ? "&nbsp;" : char; // Handle spaces properly
//             if (char === " ") span.classList.add("space"); // Add space styling
//             textContainer.appendChild(span);
//         });
//     // } else {
//     //     // Display image after all texts
//     //     let img = document.createElement("img");
//     //     img.src = imageUrl;
//     //     img.classList.add("image");
//     //     textContainer.appendChild(img);
//     // }

//     // Move to next item (reset after image)
//     index = (index + 1) % (texts.length + 1);
// }

// displayContent();
// setInterval(displayContent, 3000);

if(document.querySelector('.home_banner') && document.querySelector('.home_banner').dataset.movingText){
  const texts = document.querySelector('.home_banner').dataset.movingText;
  let index = 0;
  const textContainer = document.getElementById("text_animating");
  function displayContent() {
    textContainer.innerHTML = "";
    const currentText = texts.split(",")[index];
    if(currentText){
      currentText.split("").forEach((char, i) => {
        let span = document.createElement("span");
        span.classList.add("letter");
        span.style.animationDelay = `${i * 0.05}s`; // faster delay
        span.innerHTML = char === " " ? "&nbsp;" : char;
        if (char === " ") span.classList.add("space");
        textContainer.appendChild(span);
      });
      index = (index + 1) % texts.split(",").length;
    }
  }
  displayContent();
  setInterval(displayContent, 3000);
}


// Contact form popup Start

var contact_pop = document.querySelectorAll('.contact_popup i'), close_pop = document.querySelector('.closePopup');
if(contact_pop.length > 0){
  contact_pop.forEach(function(popup){
    popup.addEventListener('click',function(e){
      e.preventDefault();
      document.body.classList.add('contact_popup');
      document.querySelector('.contact_popMN').classList.add('active');
    })
  })
}
if(close_pop){
  close_pop.addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('contact_popup');
    document.querySelector('.contact_popMN').classList.remove('active');
  })
}

// Contact form popup End


// Supplement Popup Start

var supplement_pop = document.querySelectorAll('.enable_supplement_popup'), supplement_pop_close = document.querySelector('.suplmnt_pop_mn .close_pop');
if(supplement_pop.length > 0){
  supplement_pop.forEach(function(popup){
    popup.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('supplement_popup');
      document.querySelector('.suplmnt_pop_mn').classList.add('active');
    })
  })
}
if(supplement_pop_close){
  supplement_pop_close.addEventListener('click',function(e){
    e.preventDefault();
    document.body.classList.remove('supplement_popup');
    document.querySelector('.suplmnt_pop_mn').classList.remove('active');
  })
}

// Supplement Popup End

document.querySelector('.dropdownToggle').addEventListener('click',function(e){
  e.preventDefault();
  this.parentNode.classList.toggle('active');
})

$(document).on("click", ".features-list", function(e) {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $(".cus-testimonial-section").offset().top
  }, 900); 
});